import { fmtCAD } from "@/lib/format";

export const money = fmtCAD;
export const signedMoney = (n) => (Number(n) < 0 ? `− ${fmtCAD(Math.abs(n))}` : fmtCAD(n));

export const FREQ_LABEL = { monthly: "Mensuelle", quarterly: "Trimestrielle", annual: "Annuelle" };

export const MONTHS = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];

export const STATUS_META = {
  to_file: { label: "À produire", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  filed: { label: "Produite", cls: "bg-sky-100 text-sky-800 border-sky-200" },
  paid: { label: "Payée", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
};

export function StatusPill({ period }) {
  if (period.in_progress && period.status === "to_file") {
    return <span className="inline-block text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full border bg-slate-100 text-slate-600 border-slate-200" data-testid={`period-status-${period.key}`}>En cours</span>;
  }
  if (period.overdue) {
    return <span className="inline-block text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full border bg-rose-100 text-rose-700 border-rose-200" data-testid={`period-status-${period.key}`}>En retard</span>;
  }
  const m = STATUS_META[period.status] || STATUS_META.to_file;
  return <span className={`inline-block text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full border ${m.cls}`} data-testid={`period-status-${period.key}`}>{m.label}</span>;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  const [y, m, d] = iso.slice(0, 10).split("-");
  return `${d} ${MONTHS[parseInt(m, 10) - 1]?.slice(0, 4)}. ${y}`;
}

export const inputCls = "border rounded-lg px-3 py-2 text-sm w-full";

export function downloadBlob(data, filename) {
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(url);
}
